import { useState, useEffect } from "react";

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        Rwidth: window.innerWidth,
        Rheight: window.innerHeight,
    });

    useEffect(() => {
        const updateDimensions = () => {
            setWindowSize({
                Rwidth: window.innerWidth,
                Rheight: window.innerHeight,
            });
        };

        window.addEventListener("resize", updateDimensions);
        updateDimensions(); // 초기 크기 설정

        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    return windowSize;
};

export default useWindowSize;
